import { useEffect, useState } from "react";

export const useSuccessLottie = () => {
    const [lottie, setLottie] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const url = "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json"

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                if (isMounted) {
                    setLottie(data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                if (isMounted) {
                    setError(err.message || "Failed to load lottie");
                    setLoading(false);
                }
            });
        return () => {
            isMounted = false;
        };
    }, [url]);

    return { lottie, loading, error };
};